interface HeaderProps {
  title: string;
  subtitle?: string;
}

export default function AdminHeader({ title, subtitle }: HeaderProps) {
  return (
    <header className="bg-white border-b border-gray-100 px-8 py-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-donnos-green/10 flex items-center justify-center">
            <i className="ri-user-line text-donnos-green"></i>
          </div>
          <div className="hidden sm:block">
            <p className="text-sm font-medium text-gray-900">Administrador</p>
            <p className="text-xs text-gray-500">admin@donnos.com.br</p>
          </div>
        </div>
      </div>
    </header>
  );
}